<template>
  <div>
    <pxCard class="exam-recovery-container">
      <h4 class="exam-recovery-title">Resetar Prova de Aluno</h4>
      <h6 class="exam-recovery-input-title">Email do aluno:</h6>
      <div class="exam-recovery-form-container">
        <textarea
          ref="textarea"
          type="text"
          class="markdown-text-editor"
          :value="userEmailInput"
          @input="onEmailInput($event.target.value)"
        ></textarea>
        <px-button
          class="button-medium exam-recovery-search-user-button"
          :class="{ 'loading-button': searchingUser }"
          @click.native="searchUser()"
        >
          <span>Buscar Prova</span>
        </px-button>
      </div>
      <div v-if="assignment" class="card exam-user-assignment-container">
        <div class="exam-user-assignment-info">
          <span>Prova: </span>
          <p>{{ assignment.exam().name }}</p>
        </div>
        <div class="exam-user-assignment-info">
          <span>Aluno: </span>
          <p>{{ userEmailInAssignment }}</p>
        </div>
        <div class="exam-user-assignment-info">
          <span>Aluno iniciou: </span>
          <p>
            {{ assignment.start() }}
          </p>
        </div>
        <div class="exam-user-assignment-info">
          <span>Aluno terminou: </span>
          <p>{{ assignment.close() ? assignment.close() : 'Não terminou' }}</p>
        </div>
        <div class="exam-user-assignment-info">
          <span>Questões feitas: </span>
          <p>{{ assignment.numberOfReplies }}</p>
        </div>
        <px-button
          class="button-medium warning-btn"
          :class="{ 'loading-button': searchingUser }"
          @click.native="deleteAssignment()"
        >
          <span>Resetar Prova do aluno</span>
        </px-button>
      </div>
    </pxCard>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import pxCard from '@/dex-shared/components/px-card.vue';
import pxButton from '@/dex-shared/components/px-button.vue';

export default Vue.extend({
  components: {
    pxCard,
    pxButton,
  },
  props: {
    currentExamId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      userEmailInput: '',
      userEmailInAssignment: '',
      error: null,
      searchingUser: false,
      assignmentId: null,
    };
  },
  computed: {
    ...mapGetters({
      assignmentById: 'assignmentById',
    }),
    assignment() {
      return this.assignmentById(this.assignmentId);
    },
  },
  methods: {
    onEmailInput(input) {
      this.userEmailInput = input;
    },
    parseEmail(email) {
      return email.trim();
    },
    async searchUser() {
      this.searchingUser = true;
      this.assignmentId = null;
      this.userEmailInAssignment = '';
      try {
        this.assignmentId = await this.$store.dispatch(
          'PULL_ASSIGNMENT_BY_USER_EMAIL',
          {
            userEmail: this.parseEmail(this.userEmailInput),
            examId: this.currentExamId,
          },
        );
        this.userEmailInAssignment = this.userEmailInput;
        this.searchingUser = false;
      } catch (error) {
        this.searchingUser = false;
        if (error.message == 'AssignmentNotFound') {
          alert('Não encontramos nenhuma prova deste aluno');
        }
      }
    },
    async deleteAssignment() {
      if (
        !confirm(
          'Você tem certeza disso? Deletada a prova do aluno, não poderemos recuperá-la.',
        )
      ) {
        this.searchingUser = false;
        return;
      }
      this.searchingUser = true;
      try {
        await this.$store.dispatch('DELETE_FILES_LINKED_TO_ASSIGNMENT_ID', {
          assignmentId: this.assignment.id,
        });
        const response = await this.$store.dispatch('DELETE_ASSIGNMENT_BY_ID', {
          assignmentId: this.assignment.id,
        });
        this.searchingUser = false;
        this.userEmailInput = '';
        alert('Prova removida com sucesso');
        if (!response) {
          this.error = 'Unexpected response';
        }
      } catch (error) {
        this.error = error;
      }
    },
  },
});
</script>

<style lang="less" scoped>
.exam-recovery-container {
  padding-left: 16px;
}
.exam-recovery-title {
  margin-bottom: 16px;
  margin-top: 4px;
}
.exam-recovery-input-title {
  margin-bottom: 4px;
}
.exam-recovery-form-container {
  display: flex;
}
.exam-user-assignment-info {
  display: flex;
  margin-top: 4px;
  margin-bottom: 4px;
  span {
    margin-right: 4px;
    font-weight: bold;
  }
}
.exam-recovery-search-user-button {
  margin-left: 16px;
  min-width: 18%;
}
.exam-user-assignment-container {
  padding-left: 8px;
}
.warning-btn {
  background: red !important;
  color: white !important;
  margin-top: 16px;
  margin-bottom: 16px;
}

.markdown-text-editor {
  width: 100%;
  height: 20px;
}
</style>
